// services/sequences.js
import axiosInstance from './axiosInstance';

const SEQUENCES_API_URL = '/sequences';

const sequencesService = {
  async get(idempresa, doctype, environment = 'production') {
    try {
      const doctypeParam = doctype ? `&doctype=${doctype}` : '';
      const response = await axiosInstance.get(`${SEQUENCES_API_URL}/get.php?idempresa=${idempresa}&environment=${environment}${doctypeParam}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter sequências:', error);
      return [];
    }
  }
};

export default sequencesService;
